<template>
    <b-row>
        <b-col cols="12">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 v-if="label" class="mb-0">{{ label }}</h5>
                <div class="d-flex justify-content-end">
                    <b-button v-if="!isEditing" @click="editCustomer()" variant="primary" size="sm">Edit</b-button>
                    <b-button-group v-else size="sm">
                        <b-button @click="save()" :disabled="!customerChanged" variant="primary">Save</b-button>
                        <b-button @click="cancelEdit()" variant="primary">Cancel</b-button>
                    </b-button-group>
                </div>
            </div>

            <div v-if="thisCustomer" class="shipping-address-form">
                <b-form-group :disabled="!isEditing" class="mb-0">
                    <b-form-group label="Ship To" label-for="fullName" label-cols-sm="3" class="mb-1">
                        <b-form-input v-model="thisCustomer.address.name" id="fullName" size="sm" />
                    </b-form-group>
                    <b-form-group label="Address 1" label-for="address1" label-cols-sm="3" class="mb-1">
                        <b-form-input v-model="thisCustomer.address.line1" id="address1" size="sm" />
                    </b-form-group>
                    <b-form-group label="Address 2" label-for="address2" label-cols-sm="3" class="mb-1">
                        <b-form-input v-model="thisCustomer.address.line2" id="address2" size="sm" />
                    </b-form-group>
                    <b-form-group
                        v-if="showTaxId"
                        label="Tax ID"
                        label-for="address3"
                        label-cols-sm="3"
                        class="mb-1"
                    >
                        <b-form-input v-model="thisCustomer.address.line3" id="address3" size="sm" />
                    </b-form-group>
                    <b-row class="mb-1">
                        <b-col sm="5">
                            <b-form-group label="City" label-for="city" label-cols-sm="12" class="mb-0">
                                <b-form-input v-model="thisCustomer.address.city" id="city" size="sm" />
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group label="State" label-for="state" label-cols-sm="12" class="mb-0">
                                <b-form-input v-model="thisCustomer.address.state" id="state" size="sm" />
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group label="Zip" label-for="zip" label-cols-sm="12" class="mb-0">
                                <b-form-input v-model="thisCustomer.address.zip" id="zip" size="sm" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-form-group label="Country" label-for="country" label-cols-sm="3" class="mb-0">
                        <b-form-select
                            v-model="thisCustomer.address.country"
                            id="country"
                            size="sm"
                            :options="countries"
                            value-field="code"
                            text-field="name"
                        />
                    </b-form-group>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import countryList from "../../assets/countryList";

    export default {
        name: "ShippingAddress",
        mixins: [ countryList ],
        props: {
            customer: {
                type: Object,
                required: true,
            },
            label: {
                type: String,
                default: "",
            },
            showTaxId: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                isEditing: false,
                customerChanged: false,
                thisCustomer: { address: {} },
            }
        },
        mounted() {
            this.cloneCustomer();
        },
        methods: {
            cloneCustomer() {
                const thisCustomer = Object.assign({}, this.customer);
                if (!thisCustomer.address) {
                    thisCustomer.address = {};
                }

                // Ensure address.name exists
                if (!thisCustomer.address.name) {
                    thisCustomer.address.name = thisCustomer.fullName || '';
                }
                this.thisCustomer = thisCustomer;
                this.customerChanged = false;
            },
            editCustomer() {
                this.isEditing = true;
                this.customerChanged = false;
            },
            cancelEdit() {
                this.isEditing = false;

                this.cloneCustomer();
            },
            save() {
                this.$emit('saveCustomer', this.thisCustomer);

                this.isEditing = false;
            }
        },
        watch: {
            thisCustomer: {
                handler() {
                    this.customerChanged = true;
                },
                deep: true
            },
            customer() {
                this.isEditing = false;
            }
        }
    }
</script>

<style scoped>
.shipping-address-form .form-group {
    margin-bottom: 0.25rem;
}
.shipping-address-form .form-group:last-child {
    margin-bottom: 0;
}
</style>